export const calculateGestationData = (fum) => {
  if (!fum) return {};
  try {
    const fumDate = new Date(fum);
    const today = new Date();

    if (isNaN(fumDate.getTime())) return {};

    const diffMs = today - fumDate;
    const diffDays = diffMs / (1000 * 60 * 60 * 24);
    const weeks = Math.max(0, Math.floor(diffDays / 7));

    const fppDate = new Date(fumDate.getTime() + 280 * 24 * 60 * 60 * 1000);

    return {
      semanas_gestacion: weeks,
      fecha_probable_parto: fppDate.toISOString().split("T")[0],
    };
  } catch (e) {
    console.error("Error en calculateGestationData:", e);
    return {};
  }
};
